interface ClockIconProps
  extends Omit<React.SVGProps<SVGSVGElement>, "width" | "height" | "fill"> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const ClockIcon: React.FC<ClockIconProps> = ({
  width = 16,
  height = 17,
  fill = "#1A1A1A",
  style,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    {...props}
  >
    <path
      d="M8 16.5C3.5886 16.5 0 12.9114 0 8.5C0 4.0886 3.5886 0.5 8 0.5C12.4114 0.5 16 4.0886 16 8.5C16 12.9114 12.4114 16.5 8 16.5ZM8 1.62018C4.2057 1.62018 1.11794 4.70794 1.11794 8.50224C1.11794 12.2965 4.2057 15.3843 8 15.3843C11.7943 15.3843 14.8821 12.2965 14.8821 8.50224C14.8821 4.70794 11.7943 1.62018 8 1.62018Z"
      fill={fill}
    />
    <path
      d="M7.99995 9.05898C7.6914 9.05898 7.44098 8.80856 7.44098 8.50001V3.80688C7.44098 3.49833 7.6914 3.24791 7.99995 3.24791C8.3085 3.24791 8.55892 3.49833 8.55892 3.80688V8.50001C8.55892 8.80856 8.3085 9.05898 7.99995 9.05898Z"
      fill={fill}
    />
    <path
      d="M10.6808 9.05898H8.00224C7.69369 9.05898 7.44327 8.80856 7.44327 8.50001C7.44327 8.19145 7.69369 7.94104 8.00224 7.94104H10.6808C10.9894 7.94104 11.2398 8.19145 11.2398 8.50001C11.2398 8.80856 10.9894 9.05898 10.6808 9.05898Z"
      fill={fill}
    />
  </svg>
);
